import { getGameFromUrl, parseGameFromUrl } from '@core/utils/urlParser';
import type { GaScreen } from './events';

let userId: string | undefined;
let isDemo = false;
let currentScreen: GaScreen | undefined;

export function setAnalyticsUser(next: {
  userId?: string | null;
  isDemo?: boolean;
}): void {
  if (next.userId !== undefined) {
    userId = next.userId?.trim() || undefined;
  }
  if (next.isDemo !== undefined) {
    isDemo = next.isDemo;
  }
}

export function clearAnalyticsUser(): void {
  userId = undefined;
  isDemo = false;
}

export function setAnalyticsScreen(screen: GaScreen): void {
  currentScreen = screen;
}

export function getAnalyticsScreen(): GaScreen | undefined {
  return currentScreen;
}

export function getAnalyticsUserId(): string | undefined {
  return userId;
}

/** Params attached to every event so reports can slice by game / mode. */
export function buildAnalyticsContext(): Record<string, string | number> {
  const url = parseGameFromUrl();
  const game = url.game || getGameFromUrl() || currentScreen || 'app';
  const params: Record<string, string | number> = {
    game,
    is_demo: isDemo || url.isDemo ? 1 : 0,
  };
  if (currentScreen) params.screen = currentScreen;
  return params;
}
